<template>
  <div class="recently-browse-wrap">
    <div class="p-title-wrap">
      <em class="p-view-icon ibass ibass-view"></em>
      <span class="p-view-text">最近浏览</span>
    </div>
    <div class="p-content-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)" class="tab-wrap">
        <el-tab-pane label="项目" name="matter">
          <div>
            <recently-matter v-if="index === 1"
            ></recently-matter>
          </div>
        </el-tab-pane>
        <el-tab-pane label="任务" name="task">
          <recently-task v-if="index === 2"
          ></recently-task>
        </el-tab-pane>
        <el-tab-pane label="文档" name="document">
          <recently-document v-if="index === 3"
          ></recently-document>
        </el-tab-pane>
        <el-tab-pane label="合同" name="contract">
          <recently-contract v-if="index === 4"
          ></recently-contract>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import RecentlyTask from './components/recentlyTask'
import RecentlyMatter from './components/recentlyMatter'
import RecentlyDocument from './components/recentlyDocument'
import RecentlyContract from './components/recentlyContract'
export default {
  name: 'recentlyBrowse',
  components: {
    RecentlyTask,
    RecentlyMatter,
    RecentlyDocument,
    RecentlyContract
  },
  data () {
    return {
      activeName: 'matter',
      index: 1
    }
  },
  methods: {
    handleClick (tab) {
      if (tab === 'matter') {
        this.index = 1
        this.$analysis.track('切换项目_最近浏览/工作台模块')
      } else if (tab === 'task') {
        this.index = 2
        this.$analysis.track('切换任务_最近浏览/工作台模块')
      } else if (tab === 'document') {
        this.index = 3
        this.$analysis.track('切换文档_最近浏览/工作台模块')
      } else if (tab === 'contract') {
        this.index = 4
        this.$analysis.track('切换合同_最近浏览/工作台模块')
      }
    }
  }
}

</script>

<style lang="stylus">
  .recently-browse-wrap {
    width 100%;
    padding 24px;
    box-sizing border-box;
    /*height 384px;*/

    .p-title-wrap {
      margin-bottom 8px;
      display flex;
      /*padding 10px 10px 0;*/
      .p-view-icon {
        font-size 16px;
        width 20px;
        height 16px;
        /*background #8590A6;*/
        color #ed6c00;
      }
      .p-view-text {
        width 56px;
        height 20px;
        font-size 14px;
        color #ed6c00;
        margin-left 10px;
      }
    }
    .p-content-wrap {
      box-sizing border-box;
      /*padding 10px;*/
      .tab-wrap /deep/  {
        /*background-color transparent*/
        .el-tabs__header {
          .el-tabs__nav-wrap::after {
            height: 0;
          }
        }
        .el-tabs__item {
          font-size 12px;
        }
      }
    }
  }
</style>
